module.exports = __webpack_public_path__ + "static/media/slider1.3ff9da64.png";